import React from 'react'
import styled from 'styled-components'
import { H, P, Wrapper } from '@farewill/ui'
import { screenMin } from '@farewill/ui/helpers/responsive'
import { COLOR, GTR } from '@farewill/ui/tokens'

import { CrematoriumAttributes } from 'lib/crematoria/types'

import { PRODUCTS } from 'lib/products/constants'

import Map from 'views/general/templates/LocalFuneralPage/components/Map'

import ProductContact from 'components/ProductContact'

import data from './data'

interface Props {
  nameShort: GatsbyTypes.ContentfulLocalFuneralPage['nameShort']
  phoneNumber?: GatsbyTypes.ContentfulLocalFuneralPage['phoneNumber']
  backgroundColor?: string
  crematoria: CrematoriumAttributes[]
}

const StyledWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${screenMin.l`
    flex-direction: row;`};
`

const StyledMapWrapperInner = styled(Wrapper)`
  margin: 0 auto;
  width: 100%;
`

const MapWrapper = styled(Wrapper)`
  width: 100%;

  ${screenMin.l`
    flex: 0 0 520px;`}
`

const StyledCopyWrapperInner = styled(Wrapper)`
  margin: 0 auto;

  ${screenMin.m`
    margin-left: 0;`};
`

const CopyWrapper = styled(Wrapper)`
  flex: 1 1 50%;
  margin-top: ${GTR.L};

  ${screenMin.l`
    margin-top: 0;
    padding-left: ${GTR.XXL};
    };
 `}
`

const SliceCrematoriaMap = ({
  nameShort,
  phoneNumber,
  backgroundColor = 'transparent',
  crematoria,
}: Props): React.ReactElement => (
  <Wrapper background={backgroundColor}>
    <StyledWrapper container>
      <MapWrapper>
        <StyledMapWrapperInner>
          <Map crematoriumsList={crematoria} showMapMarker />
        </StyledMapWrapperInner>
      </MapWrapper>
      <CopyWrapper background={backgroundColor}>
        <StyledCopyWrapperInner>
          <H tag="h2" size="M" decorative color={COLOR.BLACK}>
            {data.title}
          </H>
          <P size="M" color={COLOR.BLACK}>
            {data.subtitle(nameShort ?? 'this area')}
          </P>
          <ProductContact
            cta={data.contact}
            highlightTelephoneNumber
            highlightTelephoneNumberColor="#FFDF4E"
            selectedProduct={PRODUCTS.FUNERAL}
            showSpecialists
            specialistsOutlineColor="#F9F9F9"
            telephoneNumberSize="medium"
            customPhoneNumber={phoneNumber}
            preventSwapping
          />
        </StyledCopyWrapperInner>
      </CopyWrapper>
    </StyledWrapper>
  </Wrapper>
)

export default SliceCrematoriaMap
